module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"company":"Company","backoffice":"Backoffice"},"en-US":{"company":"Company","backoffice":"Backoffice"}}')
  delete Component.options._Ctor
}
